module.exports = __webpack_public_path__ + "img/ups.ed3136ac.svg";